import { internalSystem } from './common';

export const controlDelegate = {
    name :	'Controller',
    type :	1,
    subType: 'controller',
    position: {
        x: internalSystem.position.x + internalSystem.style.width / 2 - 30,
        y: internalSystem.position.y
    },
    attributes: {
        type	:	'http_delegate',
        desc	:	'Controller delegate',
        network	:	null
    }

}


export const controlDelegateInstance = {
    "name": "Controller",
    "id": "d8a429988bf511eda1eb0242ac120002",
    "type": 5,
    "attributes": {
        "type": "22f3e73ac584d31a4bbb-201",
        "scope": "runtime",
        "monitor": true
    }
}

